export default import.meta.ROLLDOWN_FILE_URL_Thoeyg5OGzt$0m9bghM22A